import { SubwayAlertVariantIcon } from './SubwayAlertVariantIcon';

/**
 * author: Austin Andrews
 * id 486507F3-9E59-4037-B0EA-8EE514AFFABB
 * name subway-alert-variant
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subway-alert-variant.svg
 * tags
 * - Alert / Error 
 * - Transportation + Other 
 */
export const SubwayWarningVariantIcon = SubwayAlertVariantIcon;
export default SubwayWarningVariantIcon